'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var folderCollapseComponent = exports.folderCollapseComponent = {
    transclude: true,
    template: require('./folder-collapse.html'),
    bindings: {
        folderTitle: '<',
        isOpen: '<',
        showCount: '<?',
        itemCount: '<?',
        itemLabel: '<?'
    },
    controllerAs: 'vm',
    controller: function controller() {
        var vm = this;
        vm.folderOpen = true;
        vm.toggleFolder = toggleFolder;
        vm.setFolderClass = setFolderClass;
        vm.$onInit = init;

        function init() {
            vm.folderOpen = vm.isOpen ? true : false;
        }

        function toggleFolder() {
            vm.folderOpen = vm.folderOpen ? false : true;
        }

        function setFolderClass() {
            return vm.folderOpen ? 'folder is-open' : 'folder';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/common/folder-collapse.js
// module id = 916
// module chunks = 0